import Swiper from 'swiper';

let swiperActu = {
    init() {
        var blockWidth = $('.cinaps-actu .actu').width();
        $('.swiper-actu').width(blockWidth+'px');

        function image(){
            var imgHeight = $('.cinaps-actu img').height();
            $('.swiper-actu .swiper-pagination').css('top', imgHeight+'px');
            //console.log(imgHeight);
        }
        setTimeout(image, 100);





        var swiper = new Swiper('.swiper-container.swiper-actu', {
            loop: true,
            autoplay: {
                delay: 8000,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

    }
}

export default swiperActu;
